import React from 'react';
import DisabledWrapper from "@/components/DisabledWrapper";
import OracleAvatarBlue from "@/assets/img/avatar_blue.png"
import OracleAvatarBlack from "@/assets/img/avatar_black.png"
import {r} from "@/utils/responsive";

interface OracleAvatarProps extends React.HTMLAttributes<HTMLDivElement> {
}

const OracleAvatar: React.FC<OracleAvatarProps> = ({className, ...props}) => {
    return (
        <DisabledWrapper {...props} style={{
            top: '-5%',
            left: '50%',
            transform: 'translateX(-50%)',
            width: r.vmax(182),
            height: r.vmax(182),
            zIndex: 7,
        }}>
            <DisabledWrapper>
                <img src={OracleAvatarBlue} className="animate-fade-part" style={{
                    width: '100%',
                    height: '100%',
                }} alt=""/>
            </DisabledWrapper>
            <DisabledWrapper>
                <img src={OracleAvatarBlack} style={{
                    width: '100%',
                    height: '100%',
                    opacity: .3
                }} alt=""/>
            </DisabledWrapper>
        </DisabledWrapper>
    );
};

export default OracleAvatar;
